import { render, staticRenderFns } from "./CmgRewards.vue?vue&type=template&id=5b8f7844&scoped=true&lang=pug"
import script from "./cmg-rewards.ts?vue&type=script&lang=ts&external"
export * from "./cmg-rewards.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRewards.vue?vue&type=style&index=0&id=5b8f7844&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8f7844",
  null
  
)

export default component.exports